import Hint from 'www/modules/Hint'
import { initI18n } from 'www/utils'

async function init() {
  const { i18next } = await initI18n({ bundle: 'doctors.blocks/common/b-without-gratitude' })
  const mobileSelector = '.b-without-gratitude_mobile'
  const targetHintSelector = '.b-without-gratitude__question'

  const isMobile = document.querySelector(mobileSelector)
  const placement = isMobile ? 'bottom' : 'right'
  const trigger = isMobile ? 'click' : 'mouseenter'

  new Hint({
    isMobile,
    text: `${i18next.t('Если вы благодарны врачу за лечение, достаточно сказать ему об этом в отзыве. Врач считает, что деньги или конфеты — лишнее.', { ns: i18next.language })}`,
    target: targetHintSelector,
    setMaxWidth: 'small',
    tippyOptions: {
      placement,
      trigger,
      zIndex: 5,
      offset: [0, 15],
    },
  })
}

init()
